// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"396":"dccb064fc5e056d8","484":"6870c0e8859ddb40","741":"95491f95d9bd9580"}[chunkId] + ".js";
};